<template>
<!-- 运动员详情 -->
  <div class="sub-page">
      <div class="player">
        <div class="cont">
            <div class="left">
              <div class="name">运动员姓名</div>
              <div class="play-box">
                <div>
                  <div class="prompt">代表队</div>
                  <div class="info">代表队名称</div>
                  <div class="prompt">籍贯</div>
                  <div class="info">四川</div>
                </div>
                <div>
                  <div class="prompt">项目</div>
                  <div class="info">短跑</div>
                  <div class="prompt">出生年月</div>
                  <div class="info">2000.01.01</div>
                </div>
              </div>
            </div>
            <div class="center">
              <img src="../../../../assets/avatar.jpg" alt="">
            </div>
            <div class="right">
              <div class="modal-total">共计获得奖牌总数</div>
              <div class="modal-num">{{gold+silver+copper}}</div>
              <div class="line-chart">
                <div class="gold">
                  <div class="number">{{gold}}</div>
                  <div class="chart" :style="goldStyle">
                    <div class="line"></div>
                  </div>
                  <div class="name">金</div>
                </div>
                <div class="silver">
                  <div class="number">{{silver}}</div>
                  <div class="chart" :style="silverStyle">
                    <div class="line"></div>
                  </div>
                  <div class="name">银</div>
                </div>
                <div class="copper">
                  <div class="number">{{copper}}</div>
                  <div class="chart" :style="copperStyle">
                    <div class="line"></div>
                  </div>
                  <div class="name">铜</div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="main">
          <div class="big-title">个人最佳成绩</div>
          <div class="individual">
            <div class="ind-row title">
              <div class="col-1">项目</div>
              <div class="col-2">成绩</div>
              <div class="col-3">标签</div>
              <div class="col-4">奖牌</div>
              <div class="col-5">赛时年龄</div>
              <div class="col-6">比赛</div>
              <div class="col-7">比赛日期</div>
            </div>
            <div class="ind-row">
              <div class="col-1">1</div>
              <div class="col-2">12345</div>
              <div class="col-3">-</div>
              <div class="col-4">
                <img src="../../../../../district/assets/image/1.png" alt="">
              </div>
              <div class="col-5">18</div>
              <div class="col-6">
                <img src="../../../../assets/avatar.jpg" alt="">
                <span>XXX比赛名称</span>
              </div>
              <div class="col-7">2022.10.08</div>
            </div>
          </div>
          <div class="big-title">历史比赛记录</div>
          <div class="history">
            <div class="his-row title">
              <div class="col-1">比赛</div>
              <div class="col-2">比赛日期</div>
              <div class="col-3">赛事年龄</div>
              <div class="col-4">参赛项目</div>
              <div class="col-5">奖牌</div>
            </div>
            <div class="his-row">
              <div class="col-1">
                <img src="../../../../../district/assets/image/1.png" alt="">
                <span>XXX比赛名称</span>
              </div>
              <div class="col-2">2022.10.08</div>
              <div class="col-3">18</div>
              <div class="col-4">
                100米 丨 200米 丨 400米
              </div>
              <div class="col-5">
                <img src="../../../../../district/assets/image/1.png" alt="">
              </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      gold:2,
      silver:0,
      copper:3
    }
  },
  methods: {
    name() {
      
    }
  },
  computed: {
    goldStyle() {
      let style = {
        height:0,
      }
       if(this.gold){
        style.height = 100/(this.gold +this.silver+this.copper)*this.gold + 'px'
      }else{
        style.height = 8 + 'px'
      }
      return style
    },
    silverStyle() {
      let style = {
        height:0,
      }
      if(this.silver){
        style.height = 100/(this.gold +this.silver+this.copper)*this.silver + 'px'
      }else{
        style.height = 8 + 'px'
      }
      return style
    },
    copperStyle() {
     let style = {
        height:0,
      }
      if(this.copper){
      style.height = 100/(this.gold +this.silver+this.copper)*this.copper + 'px'
      }else{
        style.height = 8 + 'px'
        
      }
      return style
    }
  },
}
</script>

<style lang="scss" scoped>
.sub-page{
    width: 100%;
    margin-top: 60px;
    .player{
        width: 100%;
        margin: 0 auto;
        height: 240px;
        background-color:#F8F8F8;
        color: #000000;
        .cont{
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          .left{
            width: 240px;
            .name{
              font-size: 36px;
              font-weight: bold;
              margin-top: 10px;
              margin-bottom: 30px;
            }
            .play-box{
              display: flex;
              justify-content: space-between;
              .prompt{
                font-size: 14px;
              }
              .info{
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 20px;
              }
            }
          }
          .center{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            img{
              width: 100%;
              height: 200px; 
            }
          }
          .right{
            width: 240px;
            text-align: right;
            .modal-total{
              margin-top: 20px;
              font-size: 14px;
            }
            .modal-num{
              font-size: 18px;
              font-weight: bold;
            }
            .line-chart{
              width: 100%;
              height: 150px;
              display: flex;
              justify-content: space-between;
              text-align: center;
              .number{
                font-size: 18px;
                font-weight: bold;
              }
              .name{
                font-size: 14px;
                font-weight: bold;
              }
              .gold{
                width: 70px;
                height: 150px;
                display: flex;
                justify-content: flex-end;
                flex-direction: column;
                .chart{
                  height: 100px;
                  background: linear-gradient(153.43deg, rgba(242,210,133,1) 0%,rgba(242,210,133,0.1) 100%);
                  position: relative;
                }
              }
              .silver{
                width: 70px;
                height: 150px;
                display: flex;
                justify-content: flex-end;
                flex-direction: column;
                .chart{
                  height: 100px;
                  background: linear-gradient(153.43deg, rgba(212,212,212,1) 0%,rgba(212,212,212,0.1) 100%);
                  position: relative;
                }
              }
              .copper{
                width: 70px;
                height: 150px;
                display: flex;
                justify-content: flex-end;
                flex-direction: column;
                .chart{
                  height: 100px;
                  background: linear-gradient(153.43deg, rgba(244,193,143,1) 0%,rgba(244,193,143,0.1) 100%);
                  position: relative;
                }
              }
              .line{
                  width: 100%;
                  height: 1px;
                  background-color: #FFFFFF;
                  position: absolute;
                  top: 5px;
                  left: 0;
                }
            }
          }
        }
    }
    .main{
      width: 1200px;
      margin: 0 auto;
      .big-title{
        font-size: 20px;
        color: #000000;
        font-weight: bold;
        margin-top: 30px;
      }
      .ind-row{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: bold;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid #E1E1E1;
        text-align: center;
        .col-1{
          width: 10%;
        }
        .col-2{
          width: 10%;
        }
        .col-3{
            width: 15%;
        }
        .col-4{
          width: 10%;
          img{
            width: 50px;
            height: 50px;
          }
        }
        .col-5{
          width: 10%;
        }
        .col-6{
          width: 30%;
           text-align: left;
          img{
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin-right: 5px;
          }
        }
        .col-7{
          width: 15%;
        }
      }
      .history
      .his-row{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: bold;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid #E1E1E1;
        text-align: center;
        .col-1{
          width: 20%;
          text-align: left;
          img{
            width: 40px;
            height: 40px;
          }
        }
        .col-2{
          width: 15%;
        }
        .col-3{
            width: 15%;
        }
        .col-4{
          width: 30%;
          text-align: left;
          
        }
        .col-5{
          width: 20%;
          img{
            width: 50px;
            height:50px;
          }
        }
      }
      .title{
        font-size: 16px;
        font-weight: bold;
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/components/TrackPaylerDetail.vue